module.exports = __webpack_public_path__ + "media/images/story/top/main_image-633d6bed76f038b4af91422bedc768d5.png";